import { useState, useRef, useEffect } from 'react';

const initials = (name) => {
  if (!name) return 'U';
  const n = name.trim().split(' ');
  return n.length >= 2 ? `${n[0][0]}${n[n.length - 1][0]}`.toUpperCase() : n[0][0].toUpperCase();
};

const Header = ({ user }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const name = user?.displayName || user?.name || 'Utilizador';
  const dept = user?.department || '';

  return (
    <header className="gencrm_app__header">
      <div className="gencrm_app__header-logo">
        <img src="/logo.png" alt="GenCRM" />
        <div className="gencrm_app__header-title">
          <h1>GenCRM</h1>
          <span className="gencrm_app__header-subtitle">Powered by <strong>GenApps</strong></span>
          <div className="gencrm_app__header-version">v{__APP_VERSION__}</div>
        </div>
      </div>

      <div className="gencrm_app__header-actions">
        <div className="gencrm_app__header-user" ref={ref}>
          <button className="gencrm_app__header-user-button" onClick={() => setOpen(!open)} aria-label="Menu do utilizador">
            <div className="gencrm_app__header-user-avatar">
              {user?.avatar
                ? <img src={user.avatar} alt={name} className="gencrm_app__header-user-photo" />
                : <div className="gencrm_app__header-user-initials">{initials(name)}</div>}
            </div>
            <div className="gencrm_app__header-user-info">
              <span className="gencrm_app__header-user-name">{name}</span>
              {dept && <span className="gencrm_app__header-user-department">{dept}</span>}
            </div>
            <div className={`gencrm_app__header-user-arrow ${open ? 'rotated' : ''}`}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="2" fill="none" />
              </svg>
            </div>
          </button>

          {open && (
            <div className="gencrm_app__header-user-menu">
              <div className="gencrm_app__header-user-menu-header">
                <div className="gencrm_app__header-user-menu-avatar">
                  {user?.avatar
                    ? <img src={user.avatar} alt={name} />
                    : <div className="gencrm_app__header-user-initials">{initials(name)}</div>}
                </div>
                <div>
                  <div className="gencrm_app__header-user-menu-name">{name}</div>
                  {user?.title && <div className="gencrm_app__header-user-menu-title">{user.title}</div>}
                  {dept && <div className="gencrm_app__header-user-menu-department">{dept}</div>}
                </div>
              </div>
              <div className="gencrm_app__header-user-menu-divider" />
              <div className="gencrm_app__header-user-menu-items">
                <button className="gencrm_app__header-user-menu-item">Perfil</button>
                <button className="gencrm_app__header-user-menu-item">Configuracoes</button>
              </div>
              <div className="gencrm_app__header-user-menu-divider" />
              <div className="gencrm_app__header-user-menu-items">
                <button className="gencrm_app__header-user-menu-item gencrm_app__header-user-menu-item--logout" onClick={() => location.href = '/login'}>Sair</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
